module.exports = __webpack_public_path__ + "img/IMG_5906.cb039e38.jpg";